import React, { useState } from 'react';

import { withFormik } from 'formik';
import * as yup from 'yup';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import Input from '../../components/Input/Input';

const styles = theme => ({
  button: {
    display: 'inherit',
    margin: `${theme.spacing(2)}px auto`,
    minWidth: '300px',
    minHeight: '50px',
  },
});

const Form = (props) => {
  const {
    classes,
    loading,
    data,
    states,
    cities,
    searchAddress,
    fetchCities,
    fetchAddress,
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
  } = props;
  const checkDistrict = () => {

    if (Object.keys(searchAddress).length === 0 && searchAddress.constructor === Object) {
      return true
    } else {
      return searchAddress.bairro && searchAddress.bairro.length ? true : false
    }
  }

  const [validateCNPJ, setvalidateCNPJ] = useState("");
  const [autoValidadeCNPJ, setautoValidadeCNPJ] = useState("");

  const validarCNPJ = (cnpj) => {

    var cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj == '')
      return setvalidateCNPJ(""), false;

    if (cnpj.length != 14)
      return setvalidateCNPJ(""), false;

    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
      cnpj == "11111111111111" ||
      cnpj == "22222222222222" ||
      cnpj == "33333333333333" ||
      cnpj == "44444444444444" ||
      cnpj == "55555555555555" ||
      cnpj == "66666666666666" ||
      cnpj == "77777777777777" ||
      cnpj == "88888888888888" ||
      cnpj == "99999999999999")
      return setvalidateCNPJ(""), false;

    // Valida dígitos verificadores
    var tamanho = cnpj.length - 2
    var numeros = cnpj.substring(0, tamanho);
    var digitos = cnpj.substring(tamanho);
    var soma = 0;
    var pos = tamanho - 7;
    for (var i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
        pos = 9;
    }
    var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
      return setvalidateCNPJ(""), false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
        pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
      return setvalidateCNPJ(""), false;

    return setvalidateCNPJ(true);
  }

  const [validateCpf, setvalidateCpf] = useState("");
  const [autoValidadeCpf, setautoValidadeCpf] = useState("");

  const validateCPF = (cpf) => {
    var cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf == '') return setvalidateCpf("");
    // Elimina CPFs invalidos conhecidos	
    if (cpf.length != 11 ||
      cpf == "00000000000" ||
      cpf == "11111111111" ||
      cpf == "22222222222" ||
      cpf == "33333333333" ||
      cpf == "44444444444" ||
      cpf == "55555555555" ||
      cpf == "66666666666" ||
      cpf == "77777777777" ||
      cpf == "88888888888" ||
      cpf == "99999999999")
      return setvalidateCpf("");
    // Valida 1o digito	
    var add = 0;
    for (var i = 0; i < 9; i++)
      add += parseInt(cpf.charAt(i)) * (10 - i);
    var rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
      rev = 0;
    if (rev != parseInt(cpf.charAt(9)))
      return setvalidateCpf("");
    // Valida 2o digito	
    add = 0;
    for (i = 0; i < 10; i++)
      add += parseInt(cpf.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
      rev = 0;
    if (rev != parseInt(cpf.charAt(10)))
      return setvalidateCpf("");
    return setvalidateCpf(true);
  }

  const formFields = [
    {
      elementType: 'input',
      config: {
        type: 'text',
        name: 'socialName',
        label: 'Nome',
      },
      helperText: ' ',
    },
    {
      elementType: 'input',
      config: {
        type: 'text',
        name: 'businessName',
        label: 'Razão Social',
      },
      helperText: ' ',
    },
    {
      elementType: 'maskedInput',
      config: {
        type: 'text',
        name: 'cnpj',
        label: 'CNPJ',
        mask: [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/,
        ],
      },
      helperText: validateCNPJ === "" ? 'Coloque um CNPJ valido!' : 'CNPJ valido!',
    },
    {
      elementType: 'maskedInput',
      config: {
        type: 'text',
        name: 'cep',
        label: 'CEP',
        mask: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
      },
      helperText: 'Pesquise o endereço pelo CEP',
    },
    {
      elementType: 'maskedInput',
      config: {
        type: 'text',
        name: 'cpf',
        label: 'CPF do Administrador',
        mask: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
        required: true,
      },
      helperText: validateCpf === "" ? 'Coloque um CPF valido' : 'CPF valido!',
    },
    {
      elementType: 'input',
      config: {
        type: 'text',
        name: 'stateCod',
        label: 'Estado',
        disabled: true,
      },
      helperText: ' ',
    }, {
      elementType: 'input',
      config: {
        type: 'text',
        name: 'cityCod',
        label: 'Cidade',
        disabled: true,
      },
      helperText: ' ',
    },
    {
      elementType: 'input',
      config: {
        type: 'text',
        name: 'district',
        label: 'Bairro',
        disabled: checkDistrict(),
      },
      helperText: ' ',
    },
    {
      elementType: 'input',
      config: {
        type: 'text',
        name: 'address',
        label: 'Endereço',
      },
      helperText: ' ',
    },
  ];

  (async function () {
    //Dispara o validadro automaticamente para verificar se o cnpj já cadastrado e valido ou não.
    if (autoValidadeCNPJ === "" && values.cnpj !== undefined && values.cnpj !== null) {
      setautoValidadeCNPJ(true);
      if (props.data.cnpj !== "" && validateCNPJ === "") {
        validarCNPJ(values.cnpj);
      }
    }
  })();

  (async function () {
    //Dispara o validadro automaticamente para verificar se o cpf já cadastrado e valido ou não.
    if (autoValidadeCpf === "" && values.cpf !== undefined && values.cpf !== null) {
      setautoValidadeCpf(true);
      if (props.data.adminCPF !== "" && validateCpf === "") {
        validateCPF(values.cpf);
      }
    }
  })();


  return (
    <form onSubmit={handleSubmit}>
      <Grid item container spacing={2}>
        {formFields.map(field => (
          <Grid item xs={12} sm={6} key={field.config.name}>
            <Input
              {...field.config}
              elementType={field.elementType}
              value={values[field.config.name] || ''}
              onChange={(event) => {
                if (event.target.name === 'stateCod') {
                  fetchCities(event.target.value);
                }

                if (event.target.name === 'cep' && event.target.value.split('')[8] !== '\u2000' && event.target.value) {
                  fetchAddress(event.target.value.replace(/\D+/g, ''));
                }

                if (event.target.name === 'cnpj') {
                  validarCNPJ(event.target.value)
                }
                if (event.target.name === 'cpf') {
                  validateCPF(event.target.value)
                }

                handleChange(event);
              }}
              onBlur={handleBlur}
              required
              fullWidth
              margin="normal"
              error={errors[field.config.name] && touched[field.config.name]}
              helperText={
                (touched[field.config.name] && errors[field.config.name]) || field.helperText
              }
            />
          </Grid>
        ))}
      </Grid>
      {validateCpf == true && validateCNPJ == true ?
        (
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.button}
          >
            {loading ? <CircularProgress size={20} color="primary" /> : 'ATUALIZAR'}
          </Button>
        ) :
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className={classes.button}
          disabled={Button}
        >
          {loading ? <CircularProgress size={20} color="primary" /> : 'ATUALIZAR'}
        </Button>
      }
    </form >
  );
};

const initializeItemForm = item => item || '';

const handlerSearchAddress = (item, searchItem, field) => {
  if (searchItem) {
    return searchItem.toUpperCase();
  }
  if (field) {
    return item ? item[field] : '';
  }
  return item || '';
};

const handlerDistrict = (item, searchItem, props) => {
  if (Object.keys(props.searchAddress).length === 0 && props.searchAddress.constructor === Object) {
    return props.data.district + '';
  } else {
    if (props.searchAddress.bairro && props.searchAddress.bairro.length) {
      return props.searchAddress.bairro.toUpperCase();
    }
    return '';
  }
};

const UpdateEmployerForm = withFormik({
  enableReinitialize: true,
  mapPropsToValues: (props) => {
    return ({
      socialName: initializeItemForm(props.data.socialName),
      businessName: initializeItemForm(props.data.businessName),
      cityCod: handlerSearchAddress(props.data.city, props.searchAddress.localidade, 'name'),
      stateCod: handlerSearchAddress(props.data.stateCod, props.searchAddress.uf),
      cep: handlerSearchAddress(props.data.cep, props.searchAddress.cep),
      address: handlerSearchAddress(props.data.address, props.searchAddress.logradouro),
      district: handlerDistrict(props.data.district, props.searchAddress.bairro, props),
      cnpj: props.data.cnpj,
      cpf: props.data.adminCPF,
      logoBase64: initializeItemForm(props.data.logoBase64),
    });
  },
  validationSchema: yup.object().shape({
    socialName: yup.string().required(),
    businessName: yup.string().required(),
    cityCod: yup.string().required(),
    stateCod: yup.string().required(),
    cep: yup.string().required(),
    address: yup.string().required(),
    district: yup.string().required(),
    cnpj: yup.string().required(),
    cpf: yup.string().required(),
  }),
  handleSubmit: (values, { props }) => {
    const data = {
      ...values,
      id: props.data.id,
      cep: typeof values.cep === 'number' ? values.cep.toString() : values.cep.replace(/\D+/g, ''),
      cnpj: values.cnpj.indexOf('-') ? values.cnpj.replace(/\D+/g, '') : props.cnpj,
      adminCPF: values.cpf.indexOf('-') ? values.cpf.replace(/\D+/g, '') : props.adminCPF,
      cityCod: props.searchAddress.localidade ? props.searchAddress.ibge : props.data.cityCod,
    };
    props.onUpdateEmployer(data).catch(error => error);
  },
})(Form);

export default withStyles(styles)(UpdateEmployerForm);
